import { memo } from "react";

const PaymentMessage = memo(({ paymentData, message }) => {
  let parsedData = paymentData.body;

  if (typeof paymentData.body === "string") {
    try {
      parsedData = JSON.parse(paymentData.body);
    } catch (error) {
      return <p className="mb-0 fs-6 lh-base">{message}</p>;
    }
  }

  const getPaymentInfo = () => {
    if (parsedData?.type === "cta_url" && parsedData?.body && parsedData?.action) {
      return {
        text: parsedData.body.text,
        buttonText: parsedData.action.parameters?.display_text || "Pay Now",
        url: parsedData.action.parameters?.url,
      };
    }
    if (parsedData?.text && parsedData?.button_text && parsedData?.url) {
      return {
        text: parsedData.text,
        buttonText: parsedData.button_text,
        url: parsedData.url,
      };
    }
    return {
      text: message || "Payment request",
      buttonText: "Pay Now",
      url: null,
    };
  };

  const paymentInfo = getPaymentInfo();

  const handlePaymentClick = () => {
    if (paymentInfo.url) {
      window.open(paymentInfo.url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div
      className="payment-message"
      style={{
        maxWidth: "280px",
        width: "auto",
        borderRadius: "12px",
        padding: "16px",
        backgroundColor: "#f5f5f5",
        boxSizing: "border-box",
        margin: "0 auto",
      }}
    >
      <div
        className="payment-text mb-3"
        style={{
          fontSize: "clamp(12px, 1.2vw, 16px)",
          lineHeight: "1.5",
          color: "#000",
          fontWeight: "400",
          wordWrap: "break-word",
          whiteSpace: "pre-wrap",
          overflowWrap: "break-word",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "2.5em",
        }}
      >
        <span style={{ maxWidth: "85%", display: "inline-block" }}>
          {paymentInfo.text}
        </span>
      </div>

      <div className="payment-button-container" style={{ display: "flex", justifyContent: "center" }}>
        <button
          className="btn payment-button"
          onClick={handlePaymentClick}
          disabled={!paymentInfo.url}
          aria-label={`${paymentInfo.buttonText} — payment link`}
          style={{
            backgroundColor: "#00D664",
            borderRadius: "8px",
            padding: "8px 16px",
            fontSize: "clamp(12px, 1.1vw, 14px)",
            fontWeight: "600",
            color: "white",
            border: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            minWidth: "140px",
            cursor: paymentInfo.url ? "pointer" : "not-allowed",
            transition: "background-color 0.2s ease",
          }}
          onMouseEnter={e => { e.currentTarget.style.backgroundColor = "#00C451"; }}
          onMouseLeave={e => { e.currentTarget.style.backgroundColor = "#00D664"; }}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="currentColor"
            style={{ marginRight: "4px", flexShrink: 0 }}
            aria-hidden="true"
          >
            <path d="M19 19H5V5h7V3H5c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
          </svg>
          {paymentInfo.buttonText}
        </button>
      </div>
    </div>
  );
});

export default PaymentMessage;